import Modal from "./Modal";

// Small styled "are you sure?" dialog, matching the app's modals. Use for
// destructive or bulk actions that are easy to trigger by accident.
export default function ConfirmModal({
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  danger = false,
  onConfirm,
  onClose,
}: {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  return (
    <Modal title={title} onClose={onClose}>
      <div className="form">
        <p className="field__hint">{message}</p>
        <div className="form__actions">
          <button className="btn btn--ghost" onClick={onClose}>{cancelLabel}</button>
          <button
            className={"btn " + (danger ? "btn--danger" : "btn--primary")}
            onClick={onConfirm}
            autoFocus
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </Modal>
  );
}
